import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import our core pages
import LandingPage from './pages/LandingPage';
import OnboardingPage from './pages/OnboardingPage';

// Import global styles
import './index.css';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="app-wrapper">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;